import { message } from 'kenshin';

/**
 * 根据 value 去重 [{label,value}] 数组
 * @param {Array<{label:string,value:any}>} arr 原始数组
 * @returns {Array<{label:string,value:any}>} 去重后的数组
 */
const uniqueByValue = (arr = []) => {
  const seen = new Set();
  return arr.filter((item) => {
    if (seen.has(item.value)) return false;
    seen.add(item.value);
    return true;
  });
};

const createColumns = ({ project, customer, employee, handleTagClick }) => {
  return [
    {
      title: '是否是已确定的任务',
      type: 'text',
      data: '_baseData',
      hidden: true,
    },
    {
      title: '任务id',
      type: 'text',
      data: 'taskId',
      hidden: true,
    },
    {
      title: '',
      type: 'checkbox',
      data: 'checked',
      width: 50,
      className: 'htCenter',
      selectAll: true,
    },
    {
      title: '上报',
      type: 'text',
      width: 100,
      readOnly: true,
      renderer: (instance, td, row, col, prop, value, cellProperties) => {
        const button = document.createElement('div');
        button.className = 'table-option-btn';
        button.textContent = '点击上报';
        button.onclick = () => {
          const rowData = instance.getSourceDataAtRow(row);
          if (rowData) {
            console.log('点击了');

            if (!rowData.taskId) {
              message.error('请先设置任务、项目信息');
              return;
            }
            const taskData = {
              taskId: rowData.taskId,
              taskName: rowData.taskName,
              projectId: rowData.projectId,
              projectName: rowData.projectName,
              proServCatgId: rowData._proServCatgId,
              servCatgName: rowData.proServCatgId,
              taskBeginTime: rowData.taskBeginTime,
              taskEndTime: rowData.taskEndTime,
              taskStatus: rowData.taskStatus,
              taskRemark: rowData.taskRemark,
              contractNumber: rowData.contractNumber,
            };
            window.showRptModal(taskData);
          }
        };
        td.innerHTML = '';
        td.appendChild(button);
        return td;
      },
    },
    {
      title: 'WDP项目名',
      type: 'singleSelect',
      filterInp: true,
      data: 'projectId',
      source: project.userProjectSimpList.map((item) => ({
        label: item.projectName,
        value: item.projectId,
      })),
      width: 150,
      filter: true,
      filterType: 'select',
      filterProps: {
        options: project.userProjectSimpList.map((item) => ({
          label: item.projectName,
          value: item.projectId,
        })),
      },
    },
    {
      title: '工作包',
      type: 'singleSelect',
      filterInp: true,
      data: 'proServCatgId',
      width: 150,
      source: [],
      emptyText: '请先选择WDP项目名',
    },
    {
      title: '任务名',
      data: 'taskName',
      type: 'singleSelect',
      width: 200,
      source: [],
      hasInput: true,
      emptyText: '暂无数据',
    },
    {
      title: '标签',
      data: 'taskTagList',
      width: 150,
      readOnly: true,
      renderer: (instance, td, row, col, prop, value, cellProperties) => {
        const rowData = instance.getSourceDataAtRow(row);

        let text = '';
        if (Array.isArray(rowData.taskTagList)) {
          text = rowData.taskTagList.map((item) => item.value).join(',');
        } else if (rowData.taskTagName) {
          text = rowData.taskTagName;
        }

        td.innerHTML = '';
        const container = document.createElement('div');
        container.style.cssText = 'pointer-events: none;';

        const span = document.createElement('span');
        span.textContent = text || '请选择';
        span.title = text || '请选择';
        span.style.cssText =
          'overflow: hidden; text-overflow: ellipsis; flex: 1;';
        if (!text) {
          span.style.color = '#bfbfbf';
        }

        container.appendChild(span);

        // container.onclick = (e) => {
        //   e.stopPropagation();
        //   if (handleTagClick) {
        //     handleTagClick(rowData, row);
        //   }
        // };

        // if (cellProperties.readOnly) {
        //    container.style.backgroundColor = '#f5f5f5';
        //    container.style.cursor = 'not-allowed';
        //    container.onclick = null;
        // }

        td.appendChild(container);
        return td;
      },
    },
    {
      title: '客户',
      type: 'text',
      data: 'custName',
      readOnly: true,
      width: 100,
      filter: true,
      // source: customer.easyCustomer?.map((item) => ({
      //   label: item.value,
      //   value: item.id,
      //   color: '#aaa',
      // })),
    },
    {
      title: '合同编号',
      type: 'text',
      data: 'contractNumber',
      readOnly: true,
      width: 100,
      filter: true,
    },
    {
      title: '需求/方案是否已确认',
      type: 'checkbox',
      data: 'taskRfpConfirm',
      width: 100,
    },
    {
      title: '优先级',
      type: 'singleSelect',
      data: 'taskPriority',
      width: 80,
      source: [
        {
          label: '紧急',
          value: '0',
          color: '#f3d4d4',
        },
        {
          label: '高',
          value: '1',
          color: '#ffecdb',
        },
        {
          label: '中',
          value: '2',
          color: '#f3ecc6',
        },
        {
          label: '低',
          value: '3',
          color: '#caeadb',
        },
      ],
    },
    {
      title: '状态',
      // type: 'multiSelect',
      type: 'singleSelect',
      data: 'taskExcelStatus',
      width: 120,
      source: [
        {
          label: '规划',
          value: '0',
          color: '#e6f4ff',
        },
        {
          label: '进行中',
          value: '1',
          color: '#f3c79f',
        },
        {
          label: '交付完成',
          value: '2',
          color: '#caeadb',
        },
        {
          label: '已作废',
          value: '3',
          color: '#ffa39e',
        },
        {
          label: '已取消',
          value: '4',
          color: '#d9d9d9',
        },
      ],
    },
    {
      title: '执行类别',
      type: 'singleSelect',
      data: 'taskDoType',
      width: 100,
      filter: true,
      filterType: 'select',
      filterProps: {
        options: [
          {
            label: '策划',
            value: '0',
          },
          {
            label: '文案',
            value: '1',
          },
          {
            label: '设计',
            value: '2',
          },
          {
            label: '视频',
            value: '3',
          },
          {
            label: '技术',
            value: '4',
          },
          {
            label: '其它',
            value: '5',
          },
        ],
      },
      source: [
        {
          label: '策划',
          value: '0',
        },
        {
          label: '文案',
          value: '1',
        },
        {
          label: '设计',
          value: '2',
        },
        {
          label: '视频',
          value: '3',
        },
        {
          label: '技术',
          value: '4',
        },
        {
          label: '其它',
          value: '5',
        },
      ],
    },
    {
      title: '开始时间',
      type: 'date',
      data: 'taskBeginTime',
      width: 200,
    },
    {
      title: '结束时间',
      type: 'date',
      data: 'taskEndTime',
      width: 200,
    },
    {
      title: '对接人',
      type: 'singleSelect',
      data: 'taskDockId',
      filterInp: true,
      source: employee,
      width: 200,
      filter: true,
      filterType: 'select',
      filterProps: {
        options: uniqueByValue(employee),
      },
    },
    // {
    //   title: '负责人',
    //   type: 'singleSelect',
    //   data: 'taskLeader',
    //   filterInp: true,
    //   source: employee,
    //   width: 200,
    // },
    {
      title: '参与人',
      type: 'multiSelect',
      data: 'addTaskTeamMemberList',
      source: employee,
      filterInp: true,
      width: 200,
      filter: true,
      filterType: 'select',
      filterProps: {
        options: uniqueByValue(employee),
        mode: 'multiple',
      },
    },
    {
      data: 'rptWorkHour',
      title: '已上报/时',
      type: 'text',
      width: 100,
      readOnly: true,
    },
    {
      title: '备注（情况说明）',
      type: 'text',
      data: 'taskRemark',
      width: 200,
    },
  ];
};

export default createColumns;
